
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcHeave as ObcHeaveElement} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/heave/heave.js';
 
 
 

 
 export const ObcHeave = createComponent({
   react: React,
   tagName: 'obc-heave',
   elementClass: ObcHeaveElement,
   events: {
     
   }
  });
 
 